import styled, { css } from 'styled-components';

import { FooterRowSkeleton, PagesStepChainSkeleton } from '@sharedComponents/Skeletons';

import { UpsellingPageTitleSkeleton } from './components/UpsellingPageTitleSkeleton';

const SectionTopPadding = css`
  padding-top: 2.75rem;
`;

export const StyledButtonRow = styled(FooterRowSkeleton)`
  ${SectionTopPadding};
`;

export const StyledUpsellingTitle = styled(UpsellingPageTitleSkeleton)`
  ${SectionTopPadding};
`;

export const StyledPagesStepChain = styled(PagesStepChainSkeleton)`
  ${SectionTopPadding};
`;
